import { createSelector } from '@ngrx/store'
import { caseFeature } from './case/case.reducer'
import { MarkerDimension } from './case/case.state'
import { selectionFeature } from './selection/selection.reducer'
import { FreeSelectionsForCase, HierarchicalSelectionsForCase } from './selection/selection.state'

const { selectCaseMarkers } = caseFeature
const {
    selectSavedFreeSelections,
    selectSavedHierarchicalSelections,
    selectSavedUnsupervisedSelections,
} = selectionFeature

export const selectShowSelectionLayers = createSelector(
    selectCaseMarkers,
    selectSavedFreeSelections,
    (markers: MarkerDimension[], selections: FreeSelectionsForCase): boolean =>
        markers.length > 0 || selections.size > 0
)

export const selectShowHierarchicalSelectionLayers = createSelector(
    selectCaseMarkers,
    selectSavedHierarchicalSelections,
    (markers: MarkerDimension[], selections: HierarchicalSelectionsForCase): boolean =>
        markers.length > 0 || selections.size > 0
)

export const selectShowUnsupervisedSelectionLayers = createSelector(
    selectCaseMarkers,
    selectSavedUnsupervisedSelections,
    (markers: MarkerDimension[], selections: HierarchicalSelectionsForCase): boolean =>
        markers.length > 0 || selections.size > 0
)
